import { render, staticRenderFns } from "./ValueAdded.vue?vue&type=template&id=14611207&scoped=true"
import script from "./ValueAdded.vue?vue&type=script&lang=js"
export * from "./ValueAdded.vue?vue&type=script&lang=js"
import style0 from "./ValueAdded.vue?vue&type=style&index=0&id=14611207&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14611207",
  null
  
)

export default component.exports